import { useRequestsBase } from './useRequestsBase'

export function useLatestRequests() {
  return useRequestsBase({
    topLevelFilter: 'all',
  })
}
